module.exports = __webpack_public_path__ + "media/assets/images/landing_mobile/win-d1f4996123bb12f8e1a71ac88b4ddfde.png";